import { httpPost } from "../../services/api";
import { formatPaymentResponse } from "./utils";

export const sdkSubmitReceipt = async ({
  intentId,
  receipt,
  lang,
  receiptBillingData,
  saveCard,
}: {
  receipt: string;
  intentId: string;
  lang: string;
  receiptBillingData: Record<string, unknown>;
  saveCard?: boolean;
}) => {
  return formatPaymentResponse({
    data: await httpPost(`payments/intents/${intentId}/receipt/?lang=${lang}`, {
      receipt,
      receipt_billing_data: receiptBillingData,
      save_card: saveCard,
    }),
  });
};
